<template>
  <div class="app-container">
    <CrudTable entity="TemplateImage" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['name', { field: 'finishDescription', label: 'common.finish' }]
    };
  },
  methods: {
    generateSummary({ name }) {
      return `${name}`;
    }
  }
};
</script>
